import { Component, input } from '@angular/core';
import { RouterLink } from '@angular/router';

export interface QuickActionData {
  title: string;
  description: string;
  icon: string;
  link?: string;
  is_external_link?: boolean;
  permissionRoute?: string;
  requiredPermissions?: string[];
  requireAllPermissions?: boolean;
}

@Component({
  standalone: true,
  imports: [RouterLink],
  selector: 'lib-quick-action-card',
  template: `
    @if (!data().is_external_link) {
    <a
      [routerLink]="data().link"
      class="relative rounded-lg border border-gray-200 bg-white px-6 py-5 shadow-sm flex items-center space-x-3 hover:border-primary-500 focus:outline-none focus-visible:ring-2 focus-visible:ring-offset-2 focus-visible:ring-primary-500 focus-visible:ring-offset-white"
    >
      <div class="flex-shrink-0">
        <svg
          class="h-6 w-6 text-primary-400"
          fill="none"
          stroke="currentColor"
          viewBox="0 0 24 24"
        >
          <path
            [attr.d]="data().icon"
            stroke-linecap="round"
            stroke-linejoin="round"
            stroke-width="2"
          ></path>
        </svg>
      </div>
      <div class="flex-1 min-w-0">
        <span class="absolute inset-0" aria-hidden="true"></span>
        <p class="text-sm font-medium text-gray-800">{{ data().title }}</p>
        <p class="text-sm text-gray-500">{{ data().description }}</p>
      </div>
    </a>
    } @else {
    <button
      type="button"
      (click)="handleActionClick($event, data().link)"
      class="relative rounded-lg border border-gray-200 bg-white px-6 py-5 shadow-sm flex items-center space-x-3 hover:border-primary-500 focus:outline-none focus-visible:ring-2 focus-visible:ring-offset-2 focus-visible:ring-primary-500 focus-visible:ring-offset-white"
    >
      <div class="flex-shrink-0">
        <svg
          class="h-6 w-6 text-primary-400"
          fill="none"
          stroke="currentColor"
          viewBox="0 0 24 24"
        >
          <path
            [attr.d]="data().icon"
            stroke-linecap="round"
            stroke-linejoin="round"
            stroke-width="2"
          ></path>
        </svg>
      </div>
      <div class="flex-1 min-w-0 flex flex-col items-start">
        <p class="text-sm font-medium text-gray-800">{{ data().title }}</p>
        <p class="text-sm text-gray-500 text-left">{{ data().description }}</p>
      </div>
    </button>
    }
  `,
})
export class QuickActionCardComponent {
  data = input.required<QuickActionData>();

  handleActionClick(event: MouseEvent, link?: string): void {
    event.preventDefault();
    event.stopPropagation();

    if (!link) {
      return;
    }

    window.open(link, '_blank');
  }
}

